import React from 'react';
import styles from './DataPrinciples.module.css';

export default function DataPrinciples() {
  return (
    <div className={styles.container}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h1 className={styles.title}>Our Data Principles</h1>

        <div className={styles.principlesSection}>
          <h2>True Ownership of Your Data</h2>
          <p>
            In today's digital landscape, your personal connections are increasingly becoming
            commoditized. Social networks and tech platforms profit from your relationships, turning
            your personal connections into business assets they control, analyze, and monetize.
          </p>
          <p>
            At MyPeopleDatabase, we believe in a fundamentally different approach:{' '}
            <strong>
              you should fully own all your data and your relationships with the people you're
              connected to
            </strong>
            . This isn't just a feature—it's our core philosophy.
          </p>
        </div>

        <div className={styles.principlesSection}>
          <h2>What Data Ownership Really Means</h2>
          <p>True data ownership means:</p>
          <ul className={styles.principlesList}>
            <li>
              <strong>Complete Control:</strong> You decide how your contact information is stored,
              organized, and used—with no algorithms making these decisions for you.
            </li>
            <li>
              <strong>Privacy by Design:</strong> Your data isn't mined for patterns to sell you
              products or build profiles about you.
            </li>
            <li>
              <strong>Relationship Integrity:</strong> Your connections remain yours alone, not
              shared or suggested to others without your explicit consent.
            </li>
            <li>
              <strong>Portability:</strong> You can export your data anytime, ensuring you're never
              locked into our platform.
            </li>
            <li>
              <strong>Digital Legacy:</strong> Your relationship data persists exactly as you
              configure it, preserving memories and connections on your terms.
            </li>
          </ul>
        </div>

        <div className={styles.principlesSection}>
          <h2>The MyPeopleDatabase Difference</h2>
          <p>
            Unlike platforms where relationships become network effects to drive engagement and
            profit, MyPeopleDatabase exists solely to help you manage your personal connections on
            your terms. We believe:
          </p>
          <ul className={styles.principlesList}>
            <li>Your contacts should never become someone else's business asset</li>
            <li>Your relationship data should serve only your needs, not corporate interests</li>
            <li>
              You should be able to maintain connections with those who have passed while keeping
              your active list current
            </li>
            <li>You deserve tools that respect your ownership of your personal network</li>
          </ul>
        </div>

        <div className={styles.principlesSection}>
          <h2>Our Commitment</h2>
          <p>
            We're committed to building products that honor your ownership of your personal data and
            relationships. In a world of increasingly exploitative data practices, MyPeopleDatabase
            stands as an alternative founded on respect for your digital autonomy and ownership.
          </p>
          <p>
            This isn't just a promise—it's designed into how we build, operate, and evolve our
            product.
          </p>
        </div>
      </div>
    </div>
  );
}
